import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  dropLessonSession,
  exitLessonPreview,
  lessonTaskActions,
  profileActions
} from 'common/modules/ReactShared';
import { tAppDispatch } from 'students/stores/rootStore';

export const logOutStorageClear = createAsyncThunk<
  void,
  void,
  { dispatch: tAppDispatch }
>('auth/logOutStorageClear_request', (_, { dispatch }) => {
  dispatch(profileActions.removeProfileData());
  dispatch(lessonTaskActions.drop());
  dispatch(dropLessonSession());
  // A preview is per tab (sessionStorage): it must not carry over into the next login in this tab.
  dispatch(exitLessonPreview());

  localStorage.clear();
});
